import * as Scrivito from "scrivito";
import defaultAvatar from "../../assets/images/user_img_square.svg";

function PersonAvatar({ widget, aspectRatio }) {
  const contactPage = widget.get("contactPage");
  const image = contactPage.get("image");
  const width = image?.metadata().get("width") || 200;
  const height = image?.metadata().get("height") || 200;

  if (!image) {
    return (
      <img
        className={`profile-pic --ratio-${aspectRatio}`}
        src={defaultAvatar}
        alt="user avatar"
      />
    );
  }

  return (
    <Scrivito.ImageTag
      content={image}
      className={`profile-pic --ratio-${aspectRatio}`}
      alt={contactPage.get("title")}
      width={width}
      height={height}
    />
  );
}

export default Scrivito.connect(PersonAvatar);
